import { all, call, put, takeLatest } from 'redux-saga/effects';
import { resolved } from 'store/createAction';
import { GET_ME } from './types';

// function* meResolvedSaga({ payload }) {
//   if (payload.user_onboarded !== '1') {
//     yield put(push('/setup'));
//   }
// }

export default function* root() {
  yield all([
    // takeLatest(resolved(GET_ME), meResolvedSaga)
  ]);
}
